<template>
    <div class="content">
        <Row type="flex" align="middle" class="mb16">
            <Col span="24">
              <Breadcrumb>
                <Breadcrumb-item to="/">首页</Breadcrumb-item>
                <Breadcrumb-item to="/my/customizedLineWork/insurance">我的投保单</Breadcrumb-item>
                <Breadcrumb-item>投保单详情</Breadcrumb-item>
              </Breadcrumb>
            </Col>
        </Row>
        <!-- 投保单基本信息 -->
        <PolicyBasicInfo class="mb16" :info="info" type="insurance" title="投保信息"/>
        <!-- 费用明细 -->
        <supportPlans :info="info" type="insurance" />
  </div>
</template>
<script>
import PolicyBasicInfo from "../common/PolicyBasicInfo";
import supportPlans from "../common/supportPlans";
export default {
  components: {
    PolicyBasicInfo,
    supportPlans
  },
  data() {
    return {
      info: {},
      billNo: this.$route.params.id,
      loading: false
    };
  },
  mounted() {
    this.getInfo();
  },
  methods: {
    async getInfo() {
      await this.$axios.post("/casual/insurance/user.json.dst", {
        billNo: this.billNo
      }).then(res => {
        this.info = res;
      });
    }
  }
};
</script>
<style lang="less" scoped>
.content {
  width: 100%;
  height: 100%;
  padding: 15px;
  box-sizing: border-box;
}
.flex {
  display: flex;
}
.flex-direction-column {
  flex-direction: column;
}
.flex-1 {
  flex: 1;
}
.item-center {
  align-items: center;
}
.quotation {
  &-title {
    font-size: 14px;
    padding: 10px;
    color: #000;
    border-top: 1px solid #f5f5f5;
    border-bottom: 1px solid #f5f5f5;
    background: #f3f3f3;
    height: 65px;
    display: flex;
    align-items: center;
  }
  &-p {
    font-size: 14px;
    padding: 10px;
    border-bottom: 1px solid #f5f5f5;
    color: #666;
    height: 65px;
    display: flex;
    align-items: center;
  }

  &-h {
    height: 100px;
    margin: 10px 0;
    overflow-y: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/haierProduct/components/my/customizedLineWork/insurance/detail.vue